module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/entities/maps/xml.json
// module id = 1066
// module chunks = 0 1 2 3 4 5 6 7